"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var colorSuccess = _a.colorSuccess,
      colorError = _a.colorError,
      x1 = _a.x1;
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 18 * x1,
      height: 18 * x1,
      borderRadius: '50%'
    },
    ok: {
      backgroundColor: colorSuccess.normal
    },
    error: {
      backgroundColor: colorError.normal
    }
  };
};